export default __webpack_public_path__ + "static/media/logoball.0e5eb753.svg";